// extracted by mini-css-extract-plugin
export default {"Button":"styles_Button__pJg5W","Button--disabled":"styles_Button--disabled__sWuYl"};